import { render, staticRenderFns } from "./issue_activity_history_modal.vue?vue&type=template&id=23ecf70d"
import script from "./issue_activity_history_modal.vue?vue&type=script&lang=ts"
export * from "./issue_activity_history_modal.vue?vue&type=script&lang=ts"
import style0 from "./issue_activity_history_modal.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../.yarn/__virtual__/vue-loader-virtual-bcca2229bc/0/cache/vue-loader-npm-15.11.1-829412283a-509a816d45.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/.yarn/cache/vue-hot-reload-api-npm-2.3.4-549ae26337-9befc0b3d6.zip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23ecf70d')) {
      api.createRecord('23ecf70d', component.options)
    } else {
      api.reload('23ecf70d', component.options)
    }
    module.hot.accept("./issue_activity_history_modal.vue?vue&type=template&id=23ecf70d", function () {
      api.rerender('23ecf70d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/issues/issue_activity_history_modal.vue"
export default component.exports